var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.833 0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667,11.167a7.5,7.5,0,1,1-7.5-7.5,7.5,7.5,0,0,1,7.5,7.5m1.667,0a9.125,9.125,0,1,0-2.673,6.494A9.167,9.167,0,0,0,20.333,11.167Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.991,18.167l2.75,2.75a.792.792,0,0,1-.083,1.25.875.875,0,0,1-1.125-.083l-3.292-3.333a.792.792,0,0,1,0-1.167l3.292-3.333a.875.875,0,0,1,1.125-.083.792.792,0,0,1,.083,1.25Z",
    transform: "translate(-10.741 -9.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.239155b71fe0bfe0e9cf6d0f59a7a360.svg";
export { ForwardRef as ReactComponent };